import React from 'react';

import { withUAPLThemedStyles } from '../../with-themed-styles';
import { AdPlacementMmaBase } from '../mma-ad-placement-base';

import {
  getBoostHeroImageCarouselStyles,
  getBoostProngFeed191x100Styles,
  getBoostCoachmark175x100Styles,
  getBoostContentHubStyles,
  getBoostMicrosoftPlusStyles,
} from '../../styles';

export const AdPlacementBoostHeroImageCarousel = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline={false}
    showLongHeadline
    showFinalUrl={false}
    showDescription
    showCallToAction
    showAdLabel={false}
    showGradient={false}
    isMultiLineShortHeadline={false}
    isMultiLineLongHeadline
    showBusinessName={false}
    showBusinessNameAdLabel={false}
    showAdsIcon={false}
  />),
  getBoostHeroImageCarouselStyles,
  { componentName: 'AdPlacementBoostHeroImageCarousel' }
);

export const AdPlacementBoostProngFeed191x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showLogo
    showLongHeadline
    showCallToAction
    showDots
  />),
  getBoostProngFeed191x100Styles,
  { componentName: 'AdPlacementBoostProngFeed191x100' }
);

export const AdPlacementBoostCoachmark175x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    isMultiLineShortHeadline
    showDescription
    showCallToAction
  />),
  getBoostCoachmark175x100Styles,
  { componentName: 'AdPlacementBoostCoachmark175x100' }
);

export const AdPlacementBoostContentHub = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    isContentHubMicrosoftPlus
    showShortHeadline
    showLongHeadline
    showCallToAction
    isMultiLineShortHeadline={false}
  />),
  getBoostContentHubStyles,
  { componentName: 'AdPlacementBoostContentHub' }
);

export const AdPlacementBoostMicrosoftPlus = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    isContentHubMicrosoftPlus
    showShortHeadline
    showLongHeadline
    showCallToAction
    isMultiLineShortHeadline={false}
  />),
  getBoostMicrosoftPlusStyles,
  { componentName: 'AdPlacementBoostMicrosoftPlus' }
);
